<template>
  <div id="login">
    <ul class="login-type list-unstyled">
      <li @click="isEmailLogin=true">
        <a href="javascript:void(0)" :class="{'active': isEmailLogin}" >{{ $t('emailLogin') }}</a>
      </li>
      <li @click="isEmailLogin=false">
        <a href="javascript:void(0)" :class="{'active': !isEmailLogin}" >{{ $t('phoneLogin') }}</a>
      </li>
    </ul>

    <email-login class="email-phone-login" v-show="isEmailLogin"></email-login>
    <phone-login class="email-phone-login" v-show="!isEmailLogin"></phone-login>


    <third-part-login class="oauth-login"></third-part-login>

    <!-- <p id="new-to-plex">{{ $t('newToPlex') }}
      <router-link to="/register">{{ $t('signUp') }}</router-link>
    </p> -->
  </div>
</template>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/formstyle";

  #login {
    max-width: 4rem;
    width: 100%;
    margin: 0  auto;
  }

  .login-type {
    clear: both;
    text-align: center;
    li {
      display: inline-block;
      a {
        font-size: 20px;
        line-height: 24px;
        font-weight: 600;
        color: #999;
        display: inline-block;
        padding-bottom: 12px;
      }
      .active {
        color: #333;
        background: linear-gradient(125deg, #416CF8 0%, #EC55FF 100%) center bottom / 40px 4px no-repeat;
      }
      &:first-child {
        margin-right: .62rem;
      }
      &:last-child {
        margin-left: .62rem;
      }
    }
  }

  .email-phone-login {
    margin-top: .4rem;
  }

  .oauth-login {
    max-width: 4rem;
  }

  #new-to-plex {
    max-width: 4rem;
    width: 100%;
    margin: 0 auto;
    color: #999;
    letter-spacing: 0;
    line-height: .16rem;
    text-align: center;
    a {
      color: #416CF8;
    }
  }
  
@media (max-width: 767px) {
  .login-type li {
    &:first-child {
      margin-right: .2rem;
    }
    &:last-child {
      margin-left: .2rem;
    }
  }
}
</style>

<script>
  import EmailLogin from '../../../components/loginform/emailLogin/EmailLogin.vue'
  import PhoneLogin from '../../../components/loginform/phoneLogin/PhoneLogin.vue'
  import ThirdPartLogin from '../../../components/loginform/oauthLogin/ThirdPartLogin.vue'
  import locales from './lang'

  export default {
    name: 'login-view',
    components: {
      EmailLogin,
      PhoneLogin,
      ThirdPartLogin
    },
    data: function () {
      return {
        isEmailLogin: true
      }
    },
    locales,
    mounted() {
      this.$store.commit('getLoginPage', true)
    },
    destroyed() {
      this.$store.commit('getLoginPage', false)
    }
  }
</script>



// WEBPACK FOOTER //
// Login.vue?7e108948